import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    card: {
        borderRadius: 8,
        border: "1px solid var(--Gray-200, #EAECF0)",
        background: "var(--Gray-50, #F9FAFB)",
        padding: 24,
        display: "flex",
        flexDirection: "column",
        gap: 24,
        boxSizing: "border-box",
        "@media (max-width: 1024px)": {
            borderRadius: 8,
            padding: 16,
            gap: 16,
        },
        "@media (max-width: 768px)": {
            borderRadius: 8,
            padding: 12,
            gap: 12,
        },
    },
    header: {
        fontWeight: 600,
        fontSize: 16,
        color: "#101828",
        lineHeight: "24px",
    },
    content: {
        display: "grid",
        gridTemplateColumns: "1fr 4fr",
        gap: 24,
        alignItems: "flex-start",
        width: "100%",
        boxSizing: "border-box",
        "@media (max-width: 768px)": {
            gridTemplateColumns: "1fr",
            gap: 12,
        },
    },
    labelSection: {
        minWidth: 200,
    },
    actionSection: {
        borderRadius: 8,
        padding: 12,
        minWidth: 0,
        maxWidth: "100%",
        boxSizing: "border-box",
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        background:'var(--Gray-100, #F2F4F7)'
    },
}));
